/**
 * component to get the details of Return Reason
 * @component
 */

import React from 'react';
import { Modal, Form, Row, Col, Select, Divider, Input, message } from 'antd';
import { allLanguages } from '../../../../../constants/constants';
import '../../../../../styles/App.css';
const FormItem = Form.Item;
const { Option } = Select;

class ReturnReasonForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  formRef = React.createRef();

  handleCancel() {
    this.props.showConfigureModal(false);
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const values = await this.formRef.current.validateFields();
  
      if (values?.language?.length > 2) {
        const initialLanguageValue = allLanguages.find(
          (language) => language.name === values.language
        );
        const newValues = {
          language: initialLanguageValue.code,
          translation: values.translation,
        };
        this.props.onOk(newValues);
      } else {
        this.props.onOk(values);
      }
  
    } catch (errorInfo) {
      message.error('Please fill all the fields', 2);
    }
  };

  componentWillUnmount() {
    this.formRef.current.resetFields();
  }

  render() {

    const filteredLanguages = this.props.filteredLanguages;
    const filteredLanguageCodes = allLanguages.filter(function (languageData) {
      return (
        filteredLanguages.filter(function (languageCode) {
          return languageCode == languageData.code;
        }).length == 0
      );
    });

    const initialLanguageValue = allLanguages.find(
      (language) => language.code === this.props.language
    );
    const remainingLanguages = filteredLanguageCodes.map((language, index) => {
      return (
        <Option value={language.code} key={language.code}>
          {language.name}
        </Option>
      );
    });

    return (
      <React.Fragment>
        <Modal
          width="50%"
          title="Return Reason"
          onOk={this.handleSubmit.bind(this)}
          okText="Save"
          cancelText="Close"
          visible={this.props.visible}
          onCancel={this.props.onCancel}
        >
          <Form
            onSubmit={this.handleSubmit.bind(this)}
            className="removeFormMargin"
            ref={this.formRef}
          >
            {this.props?.featureMultilangReturnReasons && (
              <React.Fragment>
                <Row type="flex" justify="space-around" align="middle">
                  <Col span={10}>
                    <h4 data-intercom-target="select-a-language-heading-configuration-returns-reasons">Select a language</h4>
                  </Col>
                  <Col span={10}>
                    <FormItem
                      name="language"
                      initialValue={initialLanguageValue ? initialLanguageValue.name : ''}
                      rules={[{ required: true }]}
                    >
                      <Select style={{ width: '100%' }} data-intercom-target="language-select-input-configuration-returns-reasons">
                        {remainingLanguages}
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
                <Row type="flex" justify="space-around" align="top">
                  <Col span={22}>
                    <Divider />
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row type="flex" justify="space-around" align="middle">
              <Col span={10}>
                <h4 data-intercom-target="enter-the-reason-heading-configuration-returns-reasons">Enter the Reason</h4>
              </Col>
              <Col span={10}>
                <FormItem
                  name="translation"
                  initialValue={this.props.translation}
                  rules={[{ required: true }]}
                >
                  <Input data-intercom-target="translation-input-configuration-returns-reasons" />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ReturnReasonForm;
